// historico-facturas.module.js
"use strict";

import angular from "angular";
import { HISTORICO_FACTURAS_COMPONENT } from "./historico-facturas.component";
import { HISTORICO_FACTURAS_SERVICE } from "./historico-facturas.service";

const HISTORICO_FACTURAS_MODULE = angular
    .module("historicoFacturas", [])
    .service("historicoFacturasService", HISTORICO_FACTURAS_SERVICE)
    .component("historicoFacturas", HISTORICO_FACTURAS_COMPONENT)
    .name
;

export { HISTORICO_FACTURAS_MODULE };
